import React, { useEffect, useState } from 'react';
import { Grid, Button } from '@material-ui/core';
import jwt from 'jsonwebtoken';
import { useHistory } from 'react-router-dom';
import './NotFound.scss';
import { ReactComponent as NotFoundImg } from '../../images/notfound.svg';

export default function NotFound() {
  const [roleId, setRoleId] = useState();
  const history = useHistory();

  const handleSubmit = () => {
    if (
      roleId === 1 ||
      roleId === 2 ||
      roleId === 3 ||
      roleId === 4 ||
      roleId === 5
    ) {
      history.push('/dashboard');
    }
    //  else if (roleId === 3) history.push('/mechanic');
  };

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('userData'));
    if (userData) {
      const { token } = userData;
      if (token) {
        const jwtDecodeToken = jwt.decode(token);
        const role = jwtDecodeToken.roleId;
        setRoleId(role);
      }
    }
  }, []);

  return (
    <>
      <Grid container className='NotFound'>
        {/* Features */}

        <Grid className='NotFoundLeft' item md={6} sm={6} xs={12}>
          <NotFoundImg />
        </Grid>

        <Grid className='NotFoundRight' item md={6} sm={6} xs={12}>
          <h1 className='heading'>404</h1>
          <h2 className='opps'>Oops!</h2>
          <p className='topPara'>
            We are usually a treasure chest of solutions, but we couldn’t find
            what you are looking for.
          </p>
          <p className='bottomPara'>We look forward to seeing you at home.</p>
          <Button
            onClick={handleSubmit}
            className='submitConfirmButton'
            color='primary'
          >
            Back to home
          </Button>
        </Grid>
      </Grid>
    </>
  );
}
